export class TenderPayload {
    minAmount: string = "";
    maxAmount: string = "";
    startDateFrom: string = "";
    startDateTo: string = "";
    endDateFrom: string = "";
    endDateTo: string = "";
    stateIds: Array<number> = [];
    categoryId: Array<number> = [];
    includeExpired: boolean = false;
    page: number = 1;
    sortedBy: string = "";
    dir: string = "";
    searchType: string = "";
    searchKey: string = "";

    cityIds: Array<number> = [];
    keywords: Array<number> = [];
    authorityIds: Array<number> = [];
    procurement: Array<number> = [];
    csvDownloadLimit: number = 0;

}